import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"],
    _excluded2 = ["className"];
import React from 'react';
import PropTypes from 'prop-types';
import { elementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import NavigateLeft from '@nerdwallet/react-icon/gizmo/Navigateleft';
import NavigateRight from '@nerdwallet/react-icon/gizmo/Navigateright';
import trackCarouselInteracted from './utils';

var handleClick = function handleClick(e, _ref) {
  var id = _ref.id,
      impression = _ref.impression,
      elementContent = _ref.elementContent,
      onClick = _ref.onClick;
  trackCarouselInteracted(id, impression, 'press');
  elementInteraction({
    elementName: "carousel__nav-arrows--".concat(id),
    interactionType: 'CLICK',
    sectionCategory: 'carousel',
    elementCategory: 'nav-arrows',
    elementDomType: 'button',
    elementContent: elementContent
  });

  if (onClick) {
    onClick(e);
  }
};

export var ArrowPrev = function ArrowPrev(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(event) {
      return handleClick(event, _objectSpread({
        elementContent: 'prev'
      }, props));
    },
    className: className,
    type: "button"
  }, /*#__PURE__*/React.createElement(NavigateLeft, null));
};
export var ArrowNext = function ArrowNext(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(event) {
      return handleClick(event, _objectSpread({
        elementContent: 'next'
      }, props));
    },
    className: className,
    type: "button"
  }, /*#__PURE__*/React.createElement(NavigateRight, null));
};
var arrowPropTypes = {
  /** ID used for tracking purposes. */
  id: PropTypes.string,

  /** Classes to apply to the arrow. */
  className: PropTypes.string,

  /** Optional click handler to call after default navigation. */
  onClick: PropTypes.func,

  /** The impression fired by the parent Carousel */
  impression: PropTypes.string
};
ArrowPrev.propTypes = arrowPropTypes;
ArrowNext.propTypes = arrowPropTypes;